module.exports = (Promise.resolve(__parcel__require__("./" + "Doppio.5a65c8c8.87c0f38e.js"))).then(() => parcelRequire('l6dlz'));